var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVobbizVit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1011.6 239.3",
    style: {
      enableBackground: "new 0 0 1011.6 239.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "380.5,74.3 416,74.3 370.4,200.4 335.6,200.4 290.4,74.3 327.5,74.3 353.7,167.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M530.9,185.5c-10.3,12.7-26,19.1-47,19.1c-21,0-36.7-6.4-47-19.1s-15.5-28-15.5-46c0-17.6,5.2-32.9,15.5-45.8 c10.3-12.9,26-19.4,47-19.4s36.7,6.5,47,19.4c10.3,12.9,15.5,28.2,15.5,45.8C546.4,157.4,541.2,172.7,530.9,185.5 M505.3,167.8 c5-6.6,7.5-16.1,7.5-28.3c0-12.2-2.5-21.7-7.5-28.3s-12.2-9.9-21.5-9.9s-16.5,3.3-21.6,9.9c-5,6.6-7.6,16-7.6,28.3 c0,12.2,2.5,21.7,7.6,28.3c5,6.6,12.2,10,21.6,10S500.3,174.5,505.3,167.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M673.6,92.9c-9.1-11.6-21.8-17.4-38-17.4c-9,0-16.3,1.9-22.1,5.6c-4.9,3-9.4,7.3-13.4,13V35.4h-31.9v168.2H636 c0.3,0,0.7,0,1,0c15.6-0.3,27.9-6.5,36.7-18.7c9-12.5,13.5-28.2,13.5-47.2C687.3,119.5,682.7,104.5,673.6,92.9 M646.9,167.4 c-4.6,6.6-11,10-19.3,10c-9.6,0-16.7-3.4-21.4-10.3c-4.7-6.9-7-15.5-7-26c0-8.9,1.1-16.1,3.4-21.7c4.4-10.5,12.4-15.8,24.1-15.8 c11.5,0,19.4,5.4,23.7,16.1c2.3,5.7,3.4,12.9,3.4,21.5C653.8,152,651.5,160.7,646.9,167.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M813.8,92.9c-9.1-11.6-21.8-17.4-38-17.4c-8.9,0-16.3,1.9-22.1,5.6c-4.9,3-9.4,7.3-13.4,13V35.4h-32v168.2 h67.9c0.4,0,0.7,0,1,0c15.6-0.3,27.9-6.5,36.7-18.7c9-12.5,13.5-28.2,13.5-47.2C827.5,119.5,822.9,104.5,813.8,92.9 M787.1,167.4 c-4.6,6.6-11,10-19.3,10c-9.6,0-16.7-3.4-21.4-10.3c-4.7-6.9-7-15.5-7-26c0-8.9,1.1-16.1,3.4-21.7c4.4-10.5,12.4-15.8,24.1-15.8 c11.5,0,19.4,5.4,23.7,16.1c2.3,5.7,3.4,12.9,3.4,21.5C794,152,791.7,160.7,787.1,167.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M882.5,63.7h-32.4V34.2h32.4V63.7z M850.1,78.2h32.4v122.2h-32.4V78.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "906.5,104.2 906.5,78.2 1003.1,78.2 1003.1,104.8 943.2,174.2 1005.3,174.2 1005.3,200.4 902.3,200.4  902.3,175.5 962.8,104.2  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.7,3C60.4,3,8.3,55.1,8.3,119.4s52.1,116.4,116.4,116.4S241,183.6,241,119.4S188.9,3,124.7,3z M201.7,81.5 l-72.8,124.9c-1.9,3.3-6.6,3.3-8.5,0L47.6,81.5c-1.9-3.3,0.5-7.4,4.3-7.4h81.2c4.6,0,8.3,3.7,8.3,8.4l0,33.6c0,2.7,3.6,3.7,5,1.4 L168,80.2c2.2-3.8,6.3-6.1,10.7-6.1h18.8C201.3,74,203.6,78.2,201.7,81.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVobbizVit);
export default __webpack_public_path__ + "static/media/VobbizVit.763a50cd85e4e80344a33388a3948260.svg";
export { ForwardRef as ReactComponent };